import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class BreedsService {
	async getBreeds(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Poultry/PoultryBreed`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

    async addBreed(authToken, request) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Poultry/PoultryBreed`,
				request,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}	

    async editBreed(authToken, request) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Poultry/PoultryBreed/${request.id}`,
				request.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new BreedsService();
